import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import './Navbar.css';
import logo from '../../logofisio.PNG';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Cerrar menú al cambiar de ruta
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Inicio', path: '/' },
    { name: 'Clínica', path: '/clinica' },
    { name: 'Equipo', path: '/equipo' },
    { name: 'Tratamientos', path: '/tratamientos' },
    { name: 'Tarifas', path: '/tarifas' },
    { name: 'Formación', path: '/formacion' },
    { name: 'Contacto', path: '/contacto' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="Fisioterapia Pedrola" className="logo-image" />
        </Link>

        {/* Desktop Menu */}
        <div className="navbar-desktop">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.name}
            </Link>
          ))}
          <div className="phone-buttons">
            <a href="tel:690051174" className="btn-primary-sm" title="Fisioterapia Pinseque">
              <Phone size={16} />
              <span>Pinseque: 690 05 11 74</span>
            </a>
            <a href="tel:663881580" className="btn-primary-sm" title="Fisioterapia Pedrola">
              <Phone size={16} />
              <span>Pedrola: 663 88 15 80</span>
            </a>
          </div>
        </div>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggle"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Menu */}
        <div className={`navbar-mobile ${isOpen ? 'open' : ''}`}>
          <div className="mobile-links">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`mobile-link ${location.pathname === link.path ? 'active' : ''}`}
              >
                {link.name}
              </Link>
            ))}
            <a href="tel:690051174" className="btn-primary mobile-cta">
              <Phone size={18} />
              <span>Pinseque: 690 05 11 74</span>
            </a>
            <a href="tel:663881580" className="btn-primary mobile-cta">
              <Phone size={18} />
              <span>Pedrola: 663 88 15 80</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
